import React, { memo } from 'react';
import type { CellProps } from 'react-table';

import { useStartStateFormatter } from '../../../hooks';
import type { Tournament } from '../../../types/MTT';

import TableCellBase from './TableCellBase';

const TableCellState: React.FC<CellProps<Tournament>> = memo((props) => {
  const { row } = props;
  const { formatStartState } = useStartStateFormatter();
  const displayValue = formatStartState(
    row.original.formattedState,
    row.original.regEndInt,
    row.original.whenStartInt,
    row.original.isSnG
  );
  return <TableCellBase {...props} displayValue={displayValue} />;
});

export default TableCellState;
